import Vue from 'vue'
import amplitude from 'amplitude-js'

Vue.use({
  install: (Vue) => {
    amplitude.getInstance().init("4ff97302faad7e9faddf12ac21b7a60b");
    Vue.prototype.$amplitude = amplitude;
  }
})
